<template>
    <div class="tb-checkbox">
        <a href="#" class="tb-checkbox__button"
           v-bind:class="{ 'selected' : value }"
            @click.prevent="selectOption(true)">Yes</a>

        <a href="#" class="tb-checkbox__button"
           v-bind:class="{ 'selected' : !value }"
            @click.prevent="selectOption(false)">No</a>
    </div>
</template>

<script>
export default {
    props: {
        initialvalue: {
            default: () => 0
        }
    },

    data() {
        return {
            value: false
        }
    },

    methods: {
        selectOption(value) {
            this.value = value;
            this.$emit('box-checked', this.value)
        }
    },

    created() {

    },

    mounted() {
        this.value = this.initialvalue;
    }
}
</script>

<style lang="scss">
    .tb-checkbox {

        &__button {
            border: 1px solid $color-light-blue;
            border-radius: 30px;
            background-color: transparent;
            //color: $color-white;
            padding: 0.5rem 1rem;
            transition: 0.2s ease-in;
            margin-right: 0.5rem;
            color: $color-light-blue;

            &:hover {
                color: $color-white;
                background-color: $color-gold;
                border-color: $color-gold;
            }

            &.selected {
                color: $color-white;
                border-color: $color-gold;
                background-color: $color-gold;
            }
        }
    }
</style>